<template>
  <div class="seatArea">
    <div class="seatCon" :style="{ width: seatConWidth }">
      <!-- width:calc( {{最大列数 + 一个最左侧数字排标识}} * {{单个座位宽 + 单个座位margin值}} + padding-left值（刚好一个座位大小） + padding-right值（刚好一个座位大小） ) -->
      <div class="allRow" :style="{ width: seatConWidth }">
        <div class="cinemaRoomName">
          <div class="icon"></div>
          <div class="text">{{ $store.state.selCineInfo.hall_name }}银幕</div>
          <!-- 座位图标说明 -->
          <div class="seats-img">
            <div class='seatIconItem'>
              <span class="seats-icon canBuy"></span>
              <span class="seatIconText">可选</span>
            </div>
            <div class='seatIconItem'>
              <span class="seats-icon choosed"></span>
              <span class="seatIconText">已选</span>
            </div>
            <div class='seatIconItem'>
              <span class="seats-icon selled"></span>
              <span class="seatIconText">已售</span>
            </div>
          </div>
        </div>

        <!-- row循环 -->
        <div v-if="seatList.length > 0" style="text-align: center;">
          <div v-for="(rowItem, seatRowIndex) in seatList" class="seatRow">
            <!-- absolute左侧几排标识 -->
            <div class="seatItem rowVal">
              <span v-if="rowItem">{{ rowItem.row_name }}</span>
            </div>
            <!-- seatItem -->
            <div v-if="rowItem && rowItem.columnItems.length > 0" style="display: inline-block;">
              <div v-for="(seatItem, index) in rowItem.columnItems" :class="['seatItem', seatItem ? seatItem.class : '']"
                @click="clickSeat(seatRowIndex, index)"  v-if="seatItem && seatItem.name" :style="seatItem.seat_state == 2 ? 'visibility:hidden;' : ''">
                <!-- 未选时显示列编号 -->
                <span v-if="seatItem && seatItem.flag != 2 && seatItem.class != 'choosed'"
                  class="text">{{ seatItem.column_name }}</span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    hallName: {
      type: String
    },
    max_can_buy: {
      type: Number
    },
    maxColumn: {
      type: Number
    },
    seatList: {
      type: Array
    },
    selSeatList: {
      type: Array
    },
    totalPrice: {
      type: String
    },
    isLeftToRight: {
      type: Boolean //是否从左到右命名座位
    }
  },
  computed: {
    seatConWidth: function () {
      var result = ((this.maxColumn + 1) * (27 + 5)) + 27 + 27;
      result += 'px';
      return result;
    }
  },
  methods: {
    clickSeat: function (rowIndex, colIndex) {
      console.log(rowIndex, colIndex);
      var clickSeatItem = this.seatList[rowIndex].columnItems[colIndex];
      console.log(clickSeatItem);
      //点击了座位Item
      if (clickSeatItem) {
        var copy_clickSeatItem = JSON.parse(JSON.stringify(clickSeatItem)); //深拷贝
        var selSeatList = this.selSeatList;
        var max_can_buy = this.max_can_buy;
        /*--超出购买数量--*/
        if (copy_clickSeatItem.class == 'canBuy' || copy_clickSeatItem.class == 'couple_left') {
          //单人座：1   情侣座：2
          var click_addCount = copy_clickSeatItem.flag == "N" ? 1 : 2;
          console.log(selSeatList.length, click_addCount, max_can_buy);
          if (selSeatList.length + click_addCount > max_can_buy) {
            this.$alert(`最多可购买${max_can_buy}个座位`, '提示', {
              confirmButtonText: '确定'
            });
            return;
          }
        }

        /*--未超出购买数量--*/
        //只响应：点击的是‘可选’  || ‘已选’
        if (copy_clickSeatItem.class == 'canBuy' || copy_clickSeatItem.class == 'choosed' ||
          copy_clickSeatItem.class == 'couple_left' || copy_clickSeatItem.class == 'sel_coupleLeft') {
          /*--修改座位状态（单人座 || 情侣座）--*/
          this.clickSeatCallBack(rowIndex, colIndex);
          /*--修改情侣座（另一半）状态--*/
          if (copy_clickSeatItem.flag == 'L' || copy_clickSeatItem.flag == 'R') {
            this.clickSeatCallBack(rowIndex,colIndex+1);
          }
        }
      }
    },
    clickSeatCallBack: function (rowIndex, colIndex) {
      var clickSeatItem = this.seatList[rowIndex].columnItems[colIndex];
      var copy_clickSeatItem = JSON.parse(JSON.stringify(clickSeatItem)); //深拷贝
      var selSeatList = this.selSeatList;
      var totalPrice = Number(this.totalPrice);

      //修改座位状态
      //单人
      if (copy_clickSeatItem.flag == "N") {
        copy_clickSeatItem.class = copy_clickSeatItem.class == 'canBuy' ? 'choosed' : 'canBuy';
      }
      //情侣
      else if (copy_clickSeatItem.flag == "L") {
        copy_clickSeatItem.class = copy_clickSeatItem.class == 'couple_left' ? 'sel_coupleLeft' : 'couple_left';
      }
      else if (copy_clickSeatItem.flag == "R") {
        copy_clickSeatItem.class = copy_clickSeatItem.class == 'couple_right' ? 'sel_coupleRight' : 'couple_right';
      }


      /*--处理selSeatList数组--*/
      //push？
      if (copy_clickSeatItem.class == 'choosed' || copy_clickSeatItem.class == 'sel_coupleLeft' ||
        copy_clickSeatItem.class == 'sel_coupleRight') {
        selSeatList.push(copy_clickSeatItem);
        totalPrice += Number(copy_clickSeatItem.price);
      }
      //delete？
      else {
        for (var i = 0; i < selSeatList.length; i++) {
          if (selSeatList[i].name == copy_clickSeatItem.name) {
            selSeatList.splice(i, 1);
            totalPrice -= Number(copy_clickSeatItem.price);
            break;
          }
        }
      }
      //向父组件通信
      this.$emit('clickSeat', {
        copy_clickSeatItem,
        totalPrice: totalPrice.toFixed(2),
        selSeatList
      })
    },
  }
}
</script>

<style scoped src='@/assets/css/seat_icon.css'></style>
<style scoped src='@/assets/css/seats.css'></style>
